export const CaringSunIcon = (): JSX.Element => (
  <svg width="104" height="82" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="52" cy="47" rx="29" ry="23" fill="#FDDA05" />
    <g filter="url(#a)">
      <ellipse
        rx="3.312"
        ry="2.255"
        transform="matrix(.99851 .05454 -.06003 .9982 39.488 45.713)"
        fill="#FB9378"
        fillOpacity=".38"
      />
    </g>
    <g filter="url(#b)">
      <ellipse
        rx="3.158"
        ry="2.445"
        transform="matrix(.97179 -.23587 .39702 .9178 64.801 44.778)"
        fill="#FB9378"
        fillOpacity=".38"
      />
    </g>
    <path
      d="M53.882 47.78s-.388.829-1.715 1.164c-1.328.334-2.48-1.02-2.48-1.02"
      stroke="#CFB202"
      strokeLinecap="round"
    />
    <path
      d="M48 43.76c0 1.03-.903 1.742-1.935 2.24C45.032 45.626 44 44.79 44 43.76c0-1.03 1.29-.993 2.065 0 .774-.996 1.935-1.03 1.935 0ZM60 43.76c0 1.03-.903 1.742-1.935 2.24C57.032 45.626 56 44.79 56 43.76c0-1.03 1.29-.993 2.065 0 .774-.996 1.935-1.03 1.935 0Z"
      fill="#FB9378"
    />
    <path
      d="M49.088 28.012s1.275-2.444.082-4.557c-1.193-2.112-2.47-1.85-4.172-3.418-1.702-1.569-2.72-3.841-1.26-5.401 1.462-1.56 4.606-1.124 6.093.688M54.363 28.074s-1.275-2.444-.082-4.556c1.193-2.113 2.469-1.85 4.172-3.419 1.702-1.568 2.72-3.84 1.259-5.4-1.461-1.56-4.606-1.125-6.093.688"
      stroke="#FDDA05"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M79.11 19.023c.179 2.743-1.951 4.783-4.44 6.275-2.64-.826-5.36-2.883-5.538-5.625-.179-2.743 3.047-2.852 5.15-.336 1.759-2.774 4.65-3.057 4.829-.314Z"
      fill="#FB9378"
    />
    <path
      d="M88.563 52.26c-.479 2.155-2.508 3.267-4.68 3.878-1.768-1.213-3.322-3.392-2.843-5.548.478-2.157 2.887-1.539 3.883.861 1.918-1.76 4.118-1.348 3.64.808Z"
      fill="#FF537C"
    />
    <path
      d="M20.194 36.968c.66 2.668-1.077 5.052-3.264 6.96-2.744-.348-5.784-1.892-6.444-4.56-.66-2.669 2.496-3.345 5.01-1.24 1.243-3.04 4.039-3.828 4.698-1.16Z"
      fill="#FB9378"
    />
    <path
      d="M24.863 54.476c-.134 1.413-1.259 2.29-2.504 2.86-1.13-.624-2.202-1.882-2.067-3.294.134-1.413 1.604-1.221 2.36.224 1.014-1.28 2.346-1.203 2.211.21Z"
      fill="#FB78D6"
    />
    <path
      d="M34.056 16.145c-.595 2.683-3.21 4.047-6.017 4.783-2.304-1.532-4.34-4.266-3.745-6.95.595-2.683 3.723-1.886 5.039 1.118 2.464-2.172 5.319-1.635 4.724 1.049Z"
      fill="#FF537C"
    />
    <path
      d="M90.863 37.476c-.134 1.413-1.259 2.29-2.504 2.86-1.13-.624-2.202-1.882-2.067-3.294.134-1.413 1.604-1.221 2.36.224 1.014-1.28 2.346-1.203 2.211.21Z"
      fill="#FB78D6"
    />
    <defs>
      <filter
        id="a"
        x="34.179"
        y="41.455"
        width="10.62"
        height="8.516"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="b"
        x="59.581"
        y="40.414"
        width="10.44"
        height="8.729"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
    </defs>
  </svg>
);
